export const DOCUMENT_STATUS = {
  PENDING: 'PENDING',
  PENDING_REVIEW: 'PENDING_REVIEW',
  EMPLOYEE_UPLOAD_DOC: 'EMPLOYEE_UPLOAD_DOC',
  REJECTED: 'REJECTED',
  COMPLETED: 'COMPLETED',
};
